import { useFeatureFlags } from "./use-feature-flags";

/**
 * Mag de medewerker zichzelf van werk af halen, hoe dan ook?
 *
 * Eén vraag, één antwoord, voor allebei de knoppen die hem stellen: het afmeldverzoek op een
 * ingeplande dienst en het intrekken van een aanmelding die nog geen dienst is. De api behandelt
 * die twee paden ook als één beslissing — zou de app er maar één verbergen, dan is de andere een
 * zichtbare knop die op een 400 eindigt.
 *
 * `NOT_ALLOWED` is de enige stand waarop dit `false` is. De andere standen kiezen tussen direct
 * afmelden en een verzoek aan de planner, en dat verschil merkt de medewerker pas ná het indienen;
 * het is geen reden om de knop weg te laten. Let op dat een hoge `shiftCancellationDaysPrior` hier
 * dus niets doet: die duwt alleen het directe pad dicht en eindigt alsnog in een afmeldverzoek.
 */
export function useSelfCancellationAllowed(): boolean {
  const { data: featureFlags } = useFeatureFlags();

  return featureFlags.shiftCancellationPolicy !== "NOT_ALLOWED";
}
